import { DEFAULT_FLOW_COUNT } from './constants';
import metricsStore from '@globalStore/metricsStore';

const getEcoDefaultFlows = () => {
  const ecoDefaultFlowsArray: any = [];
  const flowConfigMeta = metricsStore.getState().flowConfigMeta;
  let flowIds: any = [];
  if (Object.keys(flowConfigMeta).length) {
    //get ids in descending order of creation time
    flowIds = Object.values(flowConfigMeta)
      .sort((a: any, b: any) => b.created_at - a.created_at)
      .slice(0, DEFAULT_FLOW_COUNT)
      .map((flow: any) => flow.id);
  }
  if (flowIds.length) {
    for (const flowId of flowIds) {
      ecoDefaultFlowsArray.push(flowId);
    }
  }
  return ecoDefaultFlowsArray;
};

export const getDefaultFlowConfig = () => {
  return {
    name: `overview-flow-store`,
    flows: getEcoDefaultFlows(),
  };
};
